/**
 * Rocksoft.Apple.Sync
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SyncState = {
    None: 'None',
    Started: 'Started',
    Successful: 'Successful',
    Waiting: 'Waiting',
    Verify: 'Verify',
    Error: 'Error',
    Failed: 'Failed',
    Timeout: 'Timeout',
} as const;
export type SyncState = typeof SyncState[keyof typeof SyncState];

